export default "__VITE_ASSET__CUGVjV$X__"